<div
  [ngClass]="componentClass"
  [ngStyle]="componentStyle"
  [attr.aria-label]="identity">

  <se-icon
    *ngIf="!hasImage"
    class="se-avatar__org-icon se-icon--no-margin"
    name="shield-fill">
  </se-icon>

  <span *ngIf="!hasImage && initials" class="se-avatar__initials">
    {{ initials }}
  </span>

</div>